import { type NativeEmbedFeatureList } from '@canvas/databases-bridge-api/types';

/**
 * Returns a list of features and their enabled status.
 *
 * These features align with the milestone-based rollout plan for native database embeds.
 * Each feature corresponds to a specific milestone.
 *
 * @see https://hello.atlassian.net/wiki/spaces/CD2/pages/4737992889/Feature+New+native+embed+whiteboards+pages
 */
export function getLocalEnabledFeatureList(): NativeEmbedFeatureList {
  return {
    toolbarActionBar: true,
    flagsSnackbarsModals: false,
    helloReleaseOther: false,
    changeboarding: false,
  };
}
